import { SliderPreview } from "./SliderPreview";
export default SliderPreview;
